import SoilModel from "../models/SoilModel"
/**
 * function use to calculate value of usableService of a soil
 * @param soil 
 */
export function computeUsableReserve(soil: SoilModel): void {
  if(soil.depth) {
    soil.usable_reserve = (((+soil.fieldcapacity - +soil.wiltingpoint)*+soil.depth*10)).toFixed(0)
  }
}